import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import {
   //getRequest,
  postRequest,
//   getRequest1,
//   postRequest1,
//   postRequest2,
//   postRequest3,
//   uploadPostRequest,
//   fetchcampaign
} from "./index";
export const getAgentPerformanceExport = (data) => {
    return postRequest(URL.EXPORT_PERFORMANCE_BY_AGENT, data,ActionTypes.EXPORT_PERFORMANCE_BY_AGENT);
  };
export const getCampaignPerformanceExport = (data) => {
    return postRequest(URL.EXPORT_PERFORMANCE_BY_CAMPAIGN, data,ActionTypes.EXPORT_PERFORMANCE_BY_CAMPAIGN);
  };
  export const calenderTabActive= (data) => {
    return {
      type: ActionTypes.SET_CALENDER_STATE,
      payload: data,
    };
  };
